import React from 'react';
import PropTypes from 'prop-types';
import '../../css/CompanyDescription.scss';

export default class CompanyDescription extends React.PureComponent {
	static propTypes = {
		language: PropTypes.string.isRequired,
		companyDescription: PropTypes.string,
		companyName: PropTypes.string,
	};

	static defaultProps = {
		companyDescription: null,
		companyName: null,
	}

	render() {
		const { companyName, companyDescription, language } = this.props;
		if (!(companyName || (companyDescription && companyDescription.length > 0))) {
			return null;
		}
		return (
			<div className="col-xl-6 col-lg-6 col-12">
				<div className="company-information details-section">
					<h4>
						<i className="padding-right-15 padding-bottom-15 fa fa-briefcase"> </i>
						{window.Translator.getSlug('AboutCompany', language)}
					</h4>
					<div className="details-section">
						<ul>
							{companyName && (
								<li>
									<span>
										{window.Translator.getSlug('CompanyName', language)}
										:
									</span>
									{companyName}
								</li>
							)}
							{companyDescription && companyDescription.length > 0 && (
								<>
									<li>
										<span>
											{window.Translator.getSlug('CompanyInfo', language)}
											:
										</span>
									</li>
									{/* eslint-disable-next-line react/no-danger */}
									<li dangerouslySetInnerHTML={{ __html: companyDescription }} />
								</>
							)}
						</ul>
					</div>
				</div>
			</div>
		);
	}
}
